import useInView from "../../hooks/useInView";
import "./reveal.css";

// Wraps (or becomes) an element that fades + slides into view on scroll.
// Use `as` to render as the real element (headings, paragraphs) so no extra
// markup is added. Use the default wrapper around elements that already have
// their own hover transform (cards, chips) to avoid transform conflicts.
const Reveal = ({
  as: Tag = "div",
  delay = 0,
  variant = "",
  className = "",
  children,
  ...rest
}) => {
  const [ref, inView] = useInView();

  const classes = ["reveal", variant, inView ? "is-visible" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag
      ref={ref}
      className={classes}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
